var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning2 = function SvgWarning2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#123862"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.398 9.667c.69 0 1.25.56 1.25 1.25v8.75a1.25 1.25 0 1 1-2.5 0v-8.75c0-.69.56-1.25 1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.394 3.117a4.022 4.022 0 0 0-4.002-.001L4.496 8.83A4.04 4.04 0 0 0 2.5 12.3v11.4a4 4 0 0 0 1.992 3.468l9.895 5.714h.002c1.25.714 2.776.71 4.003.002l9.891-5.712.004-.002a4.04 4.04 0 0 0 1.996-3.47V12.3a4.02 4.02 0 0 0-1.996-3.47l-.004-.002-9.887-5.71h-.002ZM13.142.951a6.522 6.522 0 0 1 6.495-.003l.005.003 9.908 5.721a6.52 6.52 0 0 1 3.233 5.628v11.4a6.54 6.54 0 0 1-3.233 5.628l-.008.005-9.9 5.716a6.522 6.522 0 0 1-6.495.003l-.005-.003-9.9-5.716A6.5 6.5 0 0 1 0 23.7V12.3a6.54 6.54 0 0 1 3.233-5.628l.009-.004 9.9-5.717Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.401 23.333c.92 0 1.667.747 1.667 1.667v.167a1.667 1.667 0 1 1-3.334 0V25c0-.92.747-1.667 1.667-1.667Z"
  }))));
};
export default SvgWarning2;